export default __webpack_public_path__ + "static/media/404.4bc482a9.svg";